import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { typographyDefinition } from "@huub-web/ui/theme/typography";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { transition } from "@huub-web/ui/utils/transition";

import { theme } from "@huub-web/ui/theme/css/theme.css";

export const containerStyle = style({
  width: "100%",
});

export const contentStyle = style({
  padding: `${theme.spacings.s} 0 ${theme.spacings.xs}`,
});

export const titleStyle = recipe({
  base: {
    ...responsiveContainer({
      500: {
        ...typographyDefinition.bodyL,
      },
    }),
  },
});

export const buttonStyle = style({
  width: "100%",
  cursor: "pointer",
  borderRadius: theme.borderRadiuses.xxs,
  transition: transition("color"),
  ":hover": {
    color: theme.colors.primary,
  },
});

export const iconStyle = recipe({
  base: {
    transition: transition("transform"),
  },
  variants: {
    open: {
      true: {
        transform: "rotate(-180deg)",
      },
    },
  },
});
